<template>
    <v-app class="theme-xsp">
    <div class="auth-page">
        <div class="container page">
            <div class="row">
                <div class="col-md-6 offset-md-3 col-xs-12">
                    <div class="text-xs-center py-4">
                      <img src="logo_xsp.png" style="max-height: 150px;"/>
                    </div>
                    <p class="text-xs-center">
                    </p>
                    <ul v-if="errors" class="error-messages">
                        <li v-for="(v, k) in errors" :key="k">{{ v }}</li>
                    </ul>
                    <form v-on:submit.prevent="onSubmit(email, password);">
                        <fieldset class="form-group">
                            <input
                                    class="form-control form-control-lg"
                                    type="text"
                                    v-model="email"
                                    placeholder="Usuario"
                            />
                        </fieldset>
                        <fieldset class="form-group">
                            <input
                                    class="form-control form-control-lg"
                                    type="password"
                                    v-model="password"
                                    placeholder="Contraseña"
                            />
                        </fieldset>
                        <button class="btn btn-lg btn-xsp pull-xs-right">
                            Iniciar Sesión
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
    </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { LOGIN } from '../store/actions.type';
import router from '../router';

export default {
  data() {
    return {
      email: null,
      password: null,
    };
  },
  methods: {
    onSubmit(email, password) {
      this.$store.dispatch(LOGIN, { email, password }).then((data) => {
        if (data.role === 'censo') {
          router.push('/listado_colaboradores');
        } else if (data.role === 'admin_eko') {
          router.push('/captura_residentes');
        } else if (data.role === 'censo_residentes') {
          router.push('/captura_residentes');
        } else if (data.role === 'atencion_residentes' || data.role === 'censo_domesticos') {
          router.push('/captura_residentes');
        } else if (data.role === 'rh' || data.role === 'coordinador_operativo') {
          router.push('/asistencias');
        } else if (data.role === 'avisos') {
          router.push('/avisos');
        } else if (data.role === 'censo_mascotas') {
          router.push('/listado_mascotas');
        } else {
          router.push('/accesos');
        }
      });
    },
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors,
    }),
  },
};
</script>
<style type="text/css">
  .theme-xsp {
    background-color: #21232e !important;
  }
  .btn-xsp {
    color: #fff;
    background-color: rgba(90, 156, 214, 1);
    border-color: rgba(90, 156, 214, 1);
  }
  .btn-xsp:hover {
    background-color: rgba(90, 156, 214, 0.7);
  }
</style>
